<template>
  <SogPage
    id="page"
    title="Ausfuhrformular"
  >
    <!-- <SogSkeleton v-if="loadingDetails || loadingHistory || loadingUploader" /> -->
    <SogCard

      id="details"
    >
      <SogCardTitle>
        {{ _insuranceExportBlank?.blankNumber }}
      </SogCardTitle>


      <div v-if="!_loadingDetails">
        <SogCardActions :is-toolbar="true">
          <SogCardActionButton
            v-show="_isIncorectFilledVisible"
            mdi-icon="mdi-pencil-off"
            tooltip="Status als falsch ausgefüllt setzen"
            @click="setState(InsuranceExportBlankStatus.IncorrectlyFilled)"
          />
          <SogCardActionButton
            v-if="_insuranceExportBlank?.status === InsuranceExportBlankStatus.IncorrectlyFilled"
            mdi-icon="mdi-pencil"
            tooltip="Status als gültig setzen"
            @click="setState(undefined)"
          />
          <SogCardActionButton
            v-if="_isCanceldVisible"
            mdi-icon="mdi-delete-outline"
            tooltip="Status als ungültig setzen"
            @click="setState(InsuranceExportBlankStatus.Canceled)"
          />
          <SogCardActionButton
            v-if="_isDestroyedVisible"
            mdi-icon="mdi-eye-remove"
            tooltip="Mit 'vier Augen'-Prinzip physikalisch vernichten"
            @click="onDestroy()"
          />
          <SogCardActionButton
            v-if="_isArchivedVisible"
            mdi-icon="mdi-archive"
            tooltip="Status als archiviert setzen"
            @click="setState(InsuranceExportBlankStatus.Archived)"
          />

          <SogCardActionButton
            mdi-icon="mdi-paperclip-plus"
            @click="setUploaderVisiblity(true)"
          />

          <SogCardActionButton
            mdi-icon="mdi-camera"
            tooltip="Anhang fotografieren"
            @click="onTakePhoto()"
          />

          <SogCardActionButton
            :kind="SogButtonKind.Refresh"
            @click="refresh()"
          />
          <SogCardActionButton
            :kind="SogButtonKind.Back"
          />
        </SogCardActions>
      </div>

      <SogCardContent>
        <SogSkeleton v-if="_loadingDetails" />
        <InsuranceExportBlankDetailsComponent
          v-if="!_loadingDetails"
          :insurance-export-blank="_insuranceExportBlank"
        />
      </SogCardContent>
    </SogCard>

    <TempFileFormComponent
      v-show="!_loadingUploader && _uploaderVisible"
      id="uploader"
      ref="_uploader"
      v-model="_tempFileInfo"
    >
      <SogCardActions>
        <SogCardActionButton
          v-if="_isImportAndArchivedVisible"
          mdi-icon="mdi-archive"
          tooltip="Importieren und Status als archiviert setzen"
          @click="onImportAndArchived()"
        />
        <SogCardActionButton
          v-show="_tempFileInfo"
          mdi-icon="mdi-upload"
          @click="onImport()"
        >
          Importieren
        </SogCardActionButton>

        <SogCardActionButton
          :kind="SogButtonKind.Cancel"
          @click="setUploaderVisiblity(false)"
        />
      </SogCardActions>
    </TempFileFormComponent>

    <SogCard
      v-if="(_history != null && _history!.length > 0) || _loadingHistory"
    >
      <SogCardTitle>Historie</SogCardTitle>


      <SogCardContent>
        <SogSkeleton v-if="_loadingHistory" />
        <HistoryListComponent
          v-if="!_loadingHistory"
          :data="_history"
        />
      </SogCardContent>
    </SogCard>

    <SogCard v-if="!_loadingUploader && _files?.length !== 0">
      <SogCardTitle>Anhänge</SogCardTitle>
      <SogCardContent
        v-for="file in _files"
        :key="file.id"
      >
        <FileCardComponent
          :file="file"
        >
          <SogCardActionButton
            mdi-icon="mdi-delete"
            tooltip="Löschen"
            @click="onDelete(file)"
          />
          <SogCardActionButton
            mdi-icon="mdi-download"
            tooltip="Download"
            @click="onDownload(file)"
          />
        </FileCardComponent>
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">

import SogPage from '@/shared/ui/SogPage.vue';
import SogCardTitle from '@/shared/ui/SogCardTitle.vue';
import {computed, onMounted, ref} from 'vue';
import apiInsuranceExportBlank from '../api';

import InsuranceExportBlank, {InsuranceExportBlankStatus} from "@/shared/model/InsuranceExportBlank";

import InsuranceExportBlankDetailsComponent
  from '@/modules/InsuranceExportBlank/components/InsuranceExportBlankDetailsComponent.vue'
import SogCard from '@/shared/ui/SogCard.vue';

import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import SogCardContent from '@/shared/ui/SogCardContent.vue';
import HistoryListComponent from '@/modules/History/components/HistoryListComponent.vue';
import {SogButtonKind} from '@/shared/ui/types/SogButtonKind';
import {useSpinner} from '@/shared/composables/SogSpinner';
import SogCardActionButton from '@/shared/ui/SogCardActionButton.vue';
import SogCardActions from '@/shared/ui/SogCardActions.vue';
import {useAccountStore} from '@/stores/accountStore';
import getGuid from '@/shared/utils/getGuid';
import ListFile from '@/shared/model/ListFile';
import apiFileUtils from '@/modules/FileUtils/api';
import SogSkeleton from '@/shared/ui/SogSkeleton.vue';
import TempFileFormComponent from '@/modules/FileUtils/components/TempFileFormComponent.vue';
import notificationService from '@/shared/services/NotificationService';
import FileCardComponent from '@/modules/FileUtils/components/FileCardComponent.vue';
import FileInfo from "@/shared/model/FileInfo";
import apiFile from '@/shared/services/apiFile';

interface Props {
  id?: string
}

const props = withDefaults(defineProps<Props>(), {
    id: undefined,
  }
)


const _tempFileInfo = ref<FileInfo>()

const _insuranceExportBlank = ref<InsuranceExportBlank | undefined>();
const _history = ref<History[]>();
const _files = ref<ListFile[]>()

const _uploaderVisible = ref<boolean>(false)


const _loadingDetails = ref<boolean>(true);
const _loadingHistory = ref<boolean>(true);
const _loadingUploader = ref<boolean>(true);

const _detailsSpinner = useSpinner('details')
// const _historySpinner = useSpinner('history')
const _uploaderSpinner = useSpinner('uploader')

const _acountStote = useAccountStore();

const _uploader = ref<InstanceType<typeof TempFileFormComponent>>()
const _uploading = ref<boolean>(false)

const _isArchivedVisible = computed(() => {
  return _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Archived && (_files.value?.length ?? 0) > 0 && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})

const _isImportAndArchivedVisible = computed(() => {
  return _tempFileInfo.value && _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Archived && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})


const _isIncorectFilledVisible = computed(() => {
  return _insuranceExportBlank.value?.status === null
})

const _isCanceldVisible = computed(() => {
  // isRoot and not archived
  return _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Canceled && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})

const _isDestroyedVisible = computed(() => {
  // isRoot and not archived
  return _acountStote.isRoot && _insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Canceled
})


function setUploaderVisiblity(visibility: boolean) {
  _uploaderVisible.value = visibility
  _uploader.value?.clear()
}

async function setState(state: InsuranceExportBlankStatus | undefined) {
  _detailsSpinner.show()
  await apiInsuranceExportBlank.setStatus(props.id, state)
  _detailsSpinner.hide()

  await refresh()
}

onMounted(async () => {
  refresh()
})

function onDelete(file: ListFile) {
  notificationService.showYesNo(
    "Datei löschen",
    "Soll die Datei " + file.name + " wirklich gelöscht werden?",
    async () => {
      const res = await apiFileUtils.deleteFile(file?.id ?? "");
      if (res) {
        notificationService.success("Datei " + file.name + " wurde gelöscht");
        _files.value = _files.value?.filter((f) => f.id !== file.id);
      } else
        notificationService.error(
          "Datei " + file.name + " konnte nicht gelöscht werden"
        );
    }
  );
}

function onTakePhoto() {
  _uploading.value = true;
  _uploaderVisible.value = true
  _uploader.value?.takePhoto();
}

async function onDownload(file: ListFile) {
  if (!file.personId) return;
  try {
    _uploaderSpinner.show();
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId) await apiFile.downloadTempFile(fileId);
  } finally {
    _uploaderSpinner.hide();
  }
}

const _key = ref<string>()

async function refresh() {

  if (props.id == undefined) return

  _key.value = getGuid()

  const detailLoader = loadDetails(_key.value)
  const historyLoader = loadHistory(_key.value)
  const fileLoader = loadFiles(_key.value)

  await Promise.allSettled([detailLoader, historyLoader, fileLoader])
}

async function loadDetails(key: string) {
  _loadingDetails.value = true
  const res = await apiInsuranceExportBlank.load(props.id!)

  if (key === _key.value) {
    _insuranceExportBlank.value = res;
    _loadingDetails.value = false

    updateUploaderVisibility()
  }
  return true;
}

function updateUploaderVisibility() {
  if (!(_insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Canceled || _insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Archived) && _acountStote.isRoot && _files.value?.length === 0) {
    _uploaderVisible.value = true
  }
}

async function loadHistory(key: string) {
  _loadingHistory.value = true
  const res = await apiHistory.listInsuranceExportBlank(props.id!)

  if (key === _key.value) {
    _history.value = res
    _loadingHistory.value = false
  }
}

async function loadFiles(key: string) {
  _loadingUploader.value = true
  const res = await apiFileUtils.listFileStore(props.id!)

  if (key === _key.value) {
    _files.value = res
    _loadingUploader.value = false

    updateUploaderVisibility()
  }
}


async function onImport(): Promise<boolean> {
  if (!_tempFileInfo.value || !_tempFileInfo.value.id)
    return false;
  const res = await apiInsuranceExportBlank.addTempFile(_tempFileInfo.value.id, _insuranceExportBlank.value?.id, _tempFileInfo.value.name, _tempFileInfo.value.fileName);
  if (res) {
    notificationService.success("Datei " + _tempFileInfo.value.name + " wurde gespeichert")
    _tempFileInfo.value = undefined
    _uploader.value?.clear()
    _uploading.value = false
    refresh()
    return true
  }
  return false
}

async function onImportAndArchived() {
  if (await onImport()) {
    await setState(InsuranceExportBlankStatus.Archived)
    await refresh()
  }
}


function onDestroy() {
  notificationService.showYesNo(
    "Ausfuhrformular vernichten",
    "Möchten Sie die Ausfuhrvormular endgültig vernichten?",
    async () => {
      await setState(InsuranceExportBlankStatus.Destroyed)
    }
  );
}

</script>

<style scoped>
</style>
